const LANDINGSECTION = {
  NAVIMG: {
    DATABOOK: require("../assets/images/Databooklogo.png"),
    SETTINGS: require("../assets/images/Settings.png"),
    NOTIFICATIONS: require("../assets/images/Notifications.png"),
    HELP: require("../assets/images/Help.png"),
    DATABOOK_NAV: require("../assets/images/Databook.png"),
    INSIGHTS: require("../assets/images/Insights.png"),
  },
  LANDING_INFO: {
    WELCOME: require("../assets/images/Welcome.png"),
    DATASETSLAND: require("../assets/images/Datasets.png"),
    PRODUCTCATA: require("../assets/images/ProductCatalog.png"),
    JOBCATA: require("../assets/images/JobCatalog.png"),
    BICATA: require("../assets/images/BICatalog.png"),
    SERVICES: require("../assets/images/Services.png"),
    DATABASE: require("../assets/images/Datasetsicon.png"),
    VIEWALL: require("../assets/images/ViewAll.png"),
    EYE: require("../assets/images/eye.png"),
    BUSINESS: require("../assets/images/Business.png"),
    APMT: require("../assets/images/Apmt.png"),
    OCEAN: require("../assets/images/Ocean.png"),
    LNS: require("../assets/images/LnS.png"),
    DATASETS: require("../assets/images/Datasets.jpg"),
    DOMAIN: require("../assets/images/Domain.png"),
    FINANCE: require("../assets/images/Finance.png"),
    BRAND: require("../assets/images/Brand.png"),
    HR: require("../assets/images/hr.png"),
    COSTCENTRE: require("../assets/images/cost-centre.png"),
    PERSON: require("../assets/images/person.png"),
    PAYROLL: require("../assets/images/payroll.png"),
    PERFORMANCE: require("../assets/images/performance.png"),
    JOB: require("../assets/images/job.png"),
    GEOGRAPHY: require("../assets/images/geography.png"),
    ENTITY: require("../assets/images/entity.png"),
    COMPANY: require("../assets/images/company.png"),
    APPLICATION: require("../assets/images/application.png"),
    TIME: require("../assets/images/time.png"),
    SYSTEMUSER: require("../assets/images/system-user.png"),
    RECRUITMENT: require("../assets/images/recruitment.png"),
    CURRENCY: require("../assets/images/cash.png"),
    MAESTRO: require("../assets/images/Maestro.png"),
    VESSEL: require("../assets/images/Vessel.png"),
    TECHPLATFORM: require("../assets/images/techplatform.png"),
    RELEASE: require("../assets/images/Release.png"),
    DATACATALOG: require("../assets/images/datacatalog.png"),
    SUPPORT: require("../assets/images/Support.png"),
    FLEET: require("../assets/images/Fleet.png"),
    FEATURECATALOG: require("../assets/images/Feature_Catalog.png"),
    DATABOOKGPT: require("../assets/images/Databook_GPT.png"),
    QUERYGPT: require("../assets/images/QueryAssistance.png"),
    DATABOOKGPTICON: require("../assets/images/DataGPT-1.png"),
    QUERYGPTICON: require("../assets/images/DataGPT-2.png"),
    DATABOOKGPTAVATAR: require("../assets/images/DataGPT-3.png"),
    GPTUSERICON: require("../assets/images/user-icon.png"),
    FULFILLEDBY: require("../assets/images/Fulfilled_by.png"),
    TRANSPORTEDBY: require("../assets/images/Transported_By.png"),
    BUSINESSENABLING: require("../assets/images/Business_enabling.png"),
    CORPORATEPLATFORM: require("../assets/images/Corporate-platform.png"),
    PLATFORMENABLER: require("../assets/images/Platform_enabler.png"),
    MANAGEDBY: require("../assets/images/Managed-By.png"),
    THEMIS: require("../assets/images/Themis.png"),
    FEEDBACK: require("../assets/images/Feedback.png"),
    WARNING: require("../assets/images/Repot-issues.png"),
    BOOKING: require("../assets/images/Booking.png"),
    OTHERS: require("../assets/images/Others.png"),
    MASTERDATA: require("../assets/images/Master-data.png"),
    SALES: require("../assets/images/Sales.png"),
    CONTRACTS: require("../assets/images/Contacts.png"),
    HSUD: require("../assets/images/HSUD.png"),
    DND: require("../assets/images/DND.png"),
    SERVICEDELIVERY: require("../assets/images/Service-delivery.png"),
    //////////these section within this slashes needs to be removed once lineage is up////////
    LINEAGE_EQBC: require("../assets/images/Lineage-snapshot.png"),
    LINEAGE_GCSS: require("../assets/images/GCSS-cargo-snapshot.png"),
    LINEAGE_GLSM_PO: require("../assets/images/GLSM-po-snapshot.png"),
    //////////////////////////////////////////////////////////////////////////////////
    CERTIFIED_LOGO: require("../assets/images/certifiedLogo.png"),
    DATA_CATALOGUE: require("../assets/images/data_catalogue.png"),
    DATA_ASSISTANT: require("../assets/images/data_assistant.png"),
  },
  SEARCH: require("../assets/images/Search.png"),
  // DATABOOK_LANDING_URL: "/databook/landing",
  DATABOOK_LANDING_URL: "/databook/datasets",
  DATABOOK_TAGSCLASSIFICATION_URL: "/databook/tagsclassifcation",
};

export default LANDINGSECTION;
